module.exports = __webpack_public_path__ + "static/media/40.8d43c006.svg";